import axios from 'axios';
import { IProfile } from "../../../shared/models/IProfile";
const profileUrl = `${fdot.process.env.BACKEND_SERVER_HOST}/api/profile`;

export const updateProfile = async (profile: IProfile): Promise<IProfile> => {
    const response = await axios.post(`${profileUrl}/${profile.azureAdOid}`, profile);
    return response.data;
}

export const fetchProfile = async (azureAdOid: string): Promise<IProfile> => {
    const response = await axios.get(`${profileUrl}/${azureAdOid}`);
    let profile = response.data;
    return profile;
}

export const fetchOrCreateProfile = async (userProfile: IProfile): Promise<IProfile> => {
    const response = await axios.post(`${profileUrl}`, userProfile);
    return response.data;
}

export const getUserPhotoUri = async (azureAdOid: string | null | undefined): Promise<string | null> => {
    if (azureAdOid === undefined || azureAdOid === null) {
        return null;
    }
    const response = await axios.get(`${profileUrl}/${azureAdOid}/photo`);
    return response.data;
}